import {Button, Form, Col} from "react-bootstrap";
import {Formik} from "formik";
import {useEffect, useState} from "react";
import * as Yup from "yup";
import ApiManager from "../../api"
import AlertDismissible from "../../components/AlertDismissible";

export default function UserSettingsTransferForm() {
    const [initialFieldValues, setInitialFieldValues] = useState({});
    const [launchIntervalList, setLaunchIntervalList] = useState({});
    const [isSaved, setIsSaved] = useState(false)

    const validationSchema = Yup.object().shape({
        launchInterval: Yup.string().required('Поле обязательно для заполнения.')
    });

    useEffect(() => {
        new ApiManager()
            .request('user-settings')
            .then((data) => {
                const settings = {};
                for (const groupKey of Object.keys(data.data.settings)) {
                    const [group, key] = groupKey.split('.');
                    if (group === 'repeatTransfer') {
                        settings[key] = data.data.settings[groupKey];
                    }
                }

                setInitialFieldValues(settings)
                setLaunchIntervalList(data.data.repeatTransferInterval)
            })
    }, []);

    function onSubmit(values) {

        let settings = {};

        for (const key of Object.keys(values)) {
            settings[`repeatTransfer.${key}`] = values[key]
        }

        new ApiManager()
            .create('user-settings', {settings})
            .then(() => {
                setIsSaved(true)
                setTimeout(() => setIsSaved(false), 15000)
            })
    }

    return (
        <>
            <AlertDismissible
                show={isSaved}
                onClose={() => setIsSaved(false)}
                variant="success">
                Настройки сохранены
            </AlertDismissible>
            <Formik
                enableReinitialize={true}
                initialValues={initialFieldValues}
                validationSchema={validationSchema}
                onSubmit={onSubmit}
            >
                {({errors, handleChange, values, handleSubmit, setFieldValue}) => (
                    <Form noValidate onSubmit={handleSubmit}>
                        <Form.Group as={Col} lg="6" className="mb-3" controlId="launchInterval">
                            <Form.Label>Период запуска</Form.Label>
                            <Form.Select
                                name="launchInterval"
                                value={values.launchInterval}
                                onChange={ handleChange }
                                isInvalid={ !!errors.launchInterval }
                                aria-label=""
                            >
                                <option value="">Выберите период</option>
                                {Object.entries(launchIntervalList ?? {})?.map(([value, label]) => <option value={value}>{label}</option>)}
                            </Form.Select>
                            <Form.Control.Feedback type="invalid">
                                {errors.launchInterval}
                            </Form.Control.Feedback>
                        </Form.Group>
                        <Form.Group className="mb-3" controlId="isActive">
                            <Form.Check
                                type="switch"
                                name="isActive"
                                label="Включить"
                                checked={values.isActive === '1'}
                                onChange={(event) => {
                                    setFieldValue('isActive', event.target.checked ? '1' : '0')
                                }}
                                isInvalid={!!errors.isActive}
                            />
                        </Form.Group>
                        <Button type="submit" variant="primary">Сохранить</Button>
                    </Form>
                )}
            </Formik>
        </>
    )
}
